<div class="button-container">
  <app-button
    id="btn_next_step"
    (click)="nextStep()"
    [disabled]="saveButtonDisabled"
    [text]="label"
  ></app-button>
</div>
